import stylesCommon from "./stylesCommon"
import { ArrowBackCircle } from 'react-ionicons'

function loading(props) {
    return (
        <div className="container-fluid vh-100" style={stylesCommon.mainContainer}>
            <div className="pt-3">
                <ArrowBackCircle className="btn" onClick={() => props.history.push(props.page)} color={'#00bfff'} height="50px" width="50px" />
            </div>
            <div className={(props.search) ? "pt-3" : "invisible"}>
                <input type="text" className="form-control" placeholder="Search Here"/>
            </div>
            <p className="pt-3 text-center h3">{props.name} List</p>
            <div className="pt-3 text-center">
                <div className="spinner-border" style={stylesCommon.spinner}></div>
            </div>
        </div>
    );
}

export default loading



